// extracted by mini-css-extract-plugin
export default {"Italic":"FHqipRsN"};